class JobMatch {
	async getFactors(companyName) {
		const response = await fetch(`${process.env.REACT_APP_API}/smtm/employee/factors?company_name=${companyName}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async getMarketSalaries(countryId, levelId, areaId, companyName) {
		const response = await fetch(
			`${process.env.REACT_APP_API}/smtm/employee/market_salaries?country_id=${countryId}&level_id=${levelId}&area_id=${areaId}&company_name=${companyName}`,
			{
				method: 'GET',
				headers: {
					'Content-type': 'application/json',
				},
			}
		)

		return response.json()
	}

	async getMatchId(email) {
		const response = await fetch(`${process.env.REACT_APP_API}/smtm/employee/find_position/${email}`, {
			method: 'GET',
			headers: {
				'Content-type': 'application/json',
			},
		})

		return response.json()
	}

	async postNewPosition(body) {
		const response = await fetch(`${process.env.REACT_APP_API}/smtm/employee/new_position`, {
			method: 'POST',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(body),
		})

		return response.json()
	}

	async putJobMatch(body) {
		const response = await fetch(`${process.env.REACT_APP_API}/smtm/employee/job_match`, {
			method: 'PUT',
			headers: {
				'Content-type': 'application/json',
			},
			body: JSON.stringify(body),
		})

		return response.json()
	}
}

export default new JobMatch()
